import React, { useState, useEffect, useCallback } from "react";
import axios from "../utils/axiosInstance";

const fmt = (d) => d ? new Date(d).toLocaleDateString("rw-RW", { day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit" }) : "—";

const STATUS_STYLES = {
  pending:  { bg:"#fef3c7", color:"#b45309", border:"#fde68a", label:"⏳ Itegereye" },
  answered: { bg:"#dcfce7", color:"#15803d", border:"#bbf7d0", label:"✅ Yasubijwe" },
  closed:   { bg:"#f1f5f9", color:"#64748b", border:"#e2e8f0", label:"🔒 Yafungwe" },
};

export default function IbibazoAkagari() {
  const [questions, setQuestions] = useState([]);
  const [total, setTotal]         = useState(0);
  const [loading, setLoading]     = useState(true);
  const [search, setSearch]       = useState("");
  const [statusFilter, setStatus] = useState("");
  const [page, setPage]           = useState(1);
  const [expanded, setExpanded]   = useState(null);
  const [replyText, setReplyText] = useState({});
  const [replying, setReplying]   = useState(null);
  const [toast, setToast]         = useState(null);
  const [error, setError]         = useState(null);
  const LIMIT = 20;

  const notify = (msg, type = "ok") => { setToast({ msg, type }); setTimeout(() => setToast(null), 4000); };

  const fetchQuestions = useCallback(async () => {
    setLoading(true); setError(null);
    try {
      const res = await axios.get("/api/cell/questions", {
        params: { page, limit: LIMIT, search: search || undefined, status: statusFilter || undefined }
      });
      setQuestions(res.data.data || []);
      setTotal(res.data.total || 0);
    } catch { setError("Habaye ikosa mu gusoma ibibazo."); }
    finally { setLoading(false); }
  }, [page, search, statusFilter]);

  useEffect(() => { fetchQuestions(); }, [fetchQuestions]);

  const handleReply = async (qId) => {
    const text = (replyText[qId] || "").trim();
    if (!text) return notify("Injiza igisubizo mbere.", "err");
    setReplying(qId);
    try {
      await axios.put(`/api/cell/questions/${qId}/reply`, { answer: text });
      notify("✅ Igisubizo cyoherejwe neza!");
      setReplyText(prev => ({ ...prev, [qId]: "" }));
      fetchQuestions();
    } catch { notify("Habaye ikosa mu kohereza igisubizo.", "err"); }
    finally { setReplying(null); }
  };

  const totalPages = Math.ceil(total / LIMIT);

  return (
    <div style={{ fontFamily:"Nunito Sans, sans-serif", color:"#1e293b" }}>
      {/* Header */}
      <div style={{ marginBottom:20 }}>
        <h2 style={{ margin:0, fontSize:"1.25rem", fontWeight:800, color:"#1e293b", display:"flex", alignItems:"center", gap:8 }}>
          <i className="bi bi-chat-square-dots-fill" style={{ color:"#f59e0b" }} /> Reba Ibibazo Bivuye ku Isibo
        </h2>
        <p style={{ margin:"4px 0 0", fontSize:"0.78rem", color:"#64748b" }}>Ibibazo byoherejwe n'Amasibo</p>
      </div>

      {/* Stats */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))", gap:12, marginBottom:20 }}>
        {[
          { label:"Byose", value:total, color:"#1d4ed8" },
          { label:"Itegereye", value:questions.filter(q => q.status==="pending").length, color:"#b45309" },
          { label:"Yasubijwe", value:questions.filter(q => q.status==="answered").length, color:"#15803d" },
        ].map(s => (
          <div key={s.label} style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:12, padding:"14px 16px", boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
            <div style={{ fontSize:"1.4rem", fontWeight:800, color:s.color }}>{s.value}</div>
            <div style={{ fontSize:"0.7rem", color:"#64748b", fontWeight:600 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Toolbar */}
      <div style={{ display:"flex", gap:10, marginBottom:16, flexWrap:"wrap" }}>
        <div style={{ display:"flex", alignItems:"center", gap:8, flex:"1 1 220px", background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:10, padding:"0 12px", minWidth:0 }}>
          <i className="bi bi-search" style={{ color:"#94a3b8" }} />
          <input value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} placeholder="Shakisha ibibazo..."
            style={{ border:"none", background:"transparent", outline:"none", padding:"0.6rem 0.25rem", fontSize:"0.88rem", color:"#1e293b", width:"100%" }} />
          {search && <button onClick={() => { setSearch(""); setPage(1); }} style={{ background:"none", border:"none", cursor:"pointer", color:"#94a3b8", padding:0 }}><i className="bi bi-x-circle-fill" /></button>}
        </div>
        <select value={statusFilter} onChange={e => { setStatus(e.target.value); setPage(1); }}
          style={{ padding:"0.55rem 1rem", background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:10, cursor:"pointer", fontSize:"0.85rem", color:"#475569", fontWeight:600, outline:"none" }}>
          <option value="">Status Yose</option>
          <option value="pending">⏳ Itegereye</option>
          <option value="answered">✅ Yasubijwe</option>
          <option value="closed">🔒 Yafungwe</option>
        </select>
        <button onClick={fetchQuestions} disabled={loading} style={{ display:"flex", alignItems:"center", gap:6, padding:"0.55rem 1rem", background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:10, cursor:"pointer", fontSize:"0.85rem", color:"#475569", fontWeight:600 }}>
          <i className="bi bi-arrow-clockwise" /> Vugurura
        </button>
      </div>

      {loading ? (
        <div style={{ textAlign:"center", padding:"4rem 0" }}>
          <div className="spinner-border text-warning" style={{ width:"3rem", height:"3rem" }} />
          <p style={{ marginTop:"1rem", color:"#64748b" }}>Gutegereza...</p>
        </div>
      ) : error ? (
        <div style={{ textAlign:"center", padding:"3rem", background:"#fef2f2", borderRadius:14, border:"1px solid #fecaca" }}>
          <i className="bi bi-exclamation-triangle-fill" style={{ fontSize:"2rem", color:"#dc2626", display:"block", marginBottom:12 }} />
          <p style={{ color:"#dc2626", fontWeight:600, marginBottom:12 }}>{error}</p>
          <button onClick={fetchQuestions} style={{ padding:"8px 20px", background:"#dc2626", color:"#fff", border:"none", borderRadius:8, cursor:"pointer", fontWeight:600 }}>Gerageza nanone</button>
        </div>
      ) : questions.length === 0 ? (
        <div style={{ textAlign:"center", padding:"5rem 2rem", background:"#f8fafc", borderRadius:14, border:"1px solid #e2e8f0" }}>
          <i className="bi bi-chat-square-x" style={{ fontSize:"2.5rem", color:"#94a3b8", display:"block", marginBottom:12 }} />
          <h5 style={{ color:"#1e293b", fontWeight:700 }}>{search || statusFilter ? "Nta kibazo kibonetse" : "Nta kibazo cyoherejwe kuri ubu"}</h5>
        </div>
      ) : (
        <>
          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            {questions.map((q) => {
              const st = STATUS_STYLES[q.status] || STATUS_STYLES.pending;
              const isOpen = expanded === q.id;
              return (
                <div key={q.id} style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:12, overflow:"hidden", boxShadow:"0 1px 4px rgba(0,0,0,0.06)", transition:"box-shadow 0.2s" }}
                  onMouseEnter={e => e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.1)"}
                  onMouseLeave={e => e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.06)"}>

                  {/* Question row */}
                  <div style={{ padding:"14px 18px", display:"flex", alignItems:"flex-start", justifyContent:"space-between", gap:12, flexWrap:"wrap" }}>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:6, flexWrap:"wrap" }}>
                        <span style={{ padding:"3px 10px", borderRadius:20, fontSize:"0.72rem", fontWeight:700, background:st.bg, color:st.color, border:`1px solid ${st.border}` }}>{st.label}</span>
                        <span style={{ fontSize:"0.75rem", color:"#1d4ed8", fontWeight:600 }}>🏘️ {q.isibo_name || "—"}</span>
                        <span style={{ fontSize:"0.75rem", color:"#0f766e", fontWeight:600 }}>🏡 {q.mudugudu_name || "—"}</span>
                      </div>
                      <p style={{ margin:0, color:"#1e293b", fontSize:"0.9rem", lineHeight:1.6, display: isOpen ? "block" : "-webkit-box", WebkitLineClamp: isOpen ? "unset" : 2, WebkitBoxOrient:"vertical", overflow: isOpen ? "visible" : "hidden", textOverflow:"ellipsis" }}>
                        {q.question_text}
                      </p>
                    </div>
                    <div style={{ display:"flex", gap:8, flexShrink:0, flexDirection:"column", alignItems:"flex-end" }}>
                      <span style={{ fontSize:"0.72rem", color:"#94a3b8", whiteSpace:"nowrap" }}>{fmt(q.created_at)}</span>
                      <button onClick={() => setExpanded(isOpen ? null : q.id)}
                        style={{ padding:"5px 12px", borderRadius:8, border:"1px solid #e2e8f0", background:"#f8fafc", color:"#475569", fontWeight:600, fontSize:"0.78rem", cursor:"pointer" }}>
                        {isOpen ? "Fungira ↑" : "Soma Byose ↓"}
                      </button>
                    </div>
                  </div>

                  {/* Expanded: existing reply + reply form */}
                  {isOpen && (
                    <div style={{ borderTop:"1px solid #f1f5f9", padding:"14px 18px", background:"#f8fafc" }}>

                      {/* Show existing answer */}
                      {q.answer && (
                        <div style={{ marginBottom:14, padding:"12px 14px", background:"#dcfce7", border:"1px solid #bbf7d0", borderRadius:10 }}>
                          <div style={{ fontSize:"0.72rem", fontWeight:700, color:"#15803d", marginBottom:6 }}>
                            ✅ Igisubizo cyatanzwe — {fmt(q.answered_at)}
                          </div>
                          <p style={{ margin:0, color:"#166534", fontSize:"0.88rem", lineHeight:1.6 }}>{q.answer}</p>
                        </div>
                      )}

                      {/* Reply form — only show if not yet answered */}
                      {q.status !== "answered" && (
                        <div>
                          <label style={{ display:"block", fontSize:"0.75rem", fontWeight:700, color:"#475569", marginBottom:6 }}>
                            💬 Tanga Igisubizo
                          </label>
                          <textarea
                            rows={3}
                            value={replyText[q.id] || ""}
                            onChange={e => setReplyText(prev => ({ ...prev, [q.id]: e.target.value }))}
                            placeholder="Andika igisubizo hano..."
                            style={{ width:"100%", padding:"10px 12px", borderRadius:8, border:"1px solid #e2e8f0", fontSize:"0.88rem", color:"#1e293b", resize:"vertical", outline:"none", boxSizing:"border-box", background:"#fff" }}
                          />
                          <button
                            onClick={() => handleReply(q.id)}
                            disabled={replying === q.id}
                            style={{ marginTop:8, padding:"8px 20px", background: replying === q.id ? "#94a3b8" : "#f59e0b", color:"#fff", border:"none", borderRadius:8, cursor: replying === q.id ? "default" : "pointer", fontWeight:700, fontSize:"0.85rem", display:"flex", alignItems:"center", gap:6 }}>
                            {replying === q.id ? <><span className="spinner-border spinner-border-sm" /> Kohereza...</> : <><i className="bi bi-send-fill" /> Ohereza Igisubizo</>}
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:8, marginTop:20 }}>
              <button onClick={() => setPage(p => Math.max(1, p-1))} disabled={page===1}
                style={{ padding:"6px 14px", borderRadius:8, border:"1px solid #e2e8f0", background: page===1 ? "#f8fafc" : "#fff", color: page===1 ? "#94a3b8" : "#475569", fontWeight:600, cursor: page===1 ? "default" : "pointer", fontSize:"0.82rem" }}>← Imbere</button>
              <span style={{ fontSize:"0.82rem", color:"#64748b", fontWeight:600 }}>Urupapuro {page} / {totalPages}</span>
              <button onClick={() => setPage(p => Math.min(totalPages, p+1))} disabled={page===totalPages}
                style={{ padding:"6px 14px", borderRadius:8, border:"1px solid #e2e8f0", background: page===totalPages ? "#f8fafc" : "#fff", color: page===totalPages ? "#94a3b8" : "#475569", fontWeight:600, cursor: page===totalPages ? "default" : "pointer", fontSize:"0.82rem" }}>Inyuma →</button>
            </div>
          )}
        </>
      )}

      {/* Toast */}
      {toast && (
        <div style={{ position:"fixed", top:20, right:20, zIndex:9999, padding:"12px 20px", borderRadius:12, fontWeight:600, fontSize:14, background: toast.type === "err" ? "#fef2f2" : "#f0fdf4", color: toast.type === "err" ? "#991b1b" : "#166534", border:`1px solid ${toast.type === "err" ? "#fecaca" : "#bbf7d0"}`, boxShadow:"0 4px 20px rgba(0,0,0,0.1)" }}>
          {toast.msg}
        </div>
      )}
    </div>
  );
}
